export interface PaginationItem {
  valor: number | string;
  pagina: number | string;
}

export function buildPaginationItems(currentPage: number, totalPages: number): PaginationItem[] {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => ({ valor: i, pagina: i + 1 }));
  }

  const ellipsis: PaginationItem = { valor: '...', pagina: '...' };
  const first: PaginationItem = { valor: 0, pagina: 1 };
  const last: PaginationItem = { valor: totalPages - 1, pagina: totalPages };

  if (currentPage <= 3) {
    return [
      ...Array.from({ length: 5 }, (_, i) => ({ valor: i, pagina: i + 1 })),
      ellipsis,
      last,
    ];
  }

  if (currentPage >= totalPages - 3) {
    return [
      first,
      ellipsis,
      ...Array.from({ length: 5 }, (_, i) => ({
        valor: totalPages - 5 + i,
        pagina: totalPages - 4 + i,
      })),
    ];
  }

  return [
    first,
    ellipsis,
    { valor: currentPage - 1, pagina: currentPage },
    { valor: currentPage, pagina: currentPage + 1 },
    { valor: currentPage + 1, pagina: currentPage + 2 },
    ellipsis,
    last,
  ];
}
